import { createElement } from 'react';

export function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightSearchText(text, query) {
  const source = String(text ?? '');
  const needle = String(query ?? '').trim();
  if (!source) return null;
  if (!needle) return source;
  const parts = source.split(new RegExp(`(${escapeRegExp(needle)})`, 'gi'));
  return parts.map((part, index) => {
    if (part.toLowerCase() === needle.toLowerCase()) {
      return createElement(
        'mark',
        {
          key: `${part}-${index}`,
          className: 'rounded-sm bg-amber-200 px-0.5 text-slate-900 dark:bg-amber-400/40 dark:text-slate-50',
        },
        part,
      );
    }
    return part;
  });
}

export function transcriptSearchPath(item, query) {
  if (!item?.id) return null;
  const params = {};
  const q = query || item.query;
  if (q) params.q = q;
  const seconds = item.start_seconds ?? item.t;
  if (seconds != null && Number.isFinite(Number(seconds))) {
    params.t = String(Math.floor(Number(seconds)));
  }
  const search = Object.keys(params).length
    ? `?${new URLSearchParams(params).toString()}`
    : '';
  return `/transcripts/${item.id}${search}`;
}
